<div *ngIf="checkViewMode('edit')">
  <div class="addressEdit" *ngIf="!isVisible">
      <label>{{ attribute.value }}</label>
      <button type="button" class="btn btn-sm btn-secondary" *ngIf="enableEditButton" (click)="isVisible = true">
          <i class="fas fa-pen"></i> Editar endereço</button>
  </div>
  <div class="addressFields" *ngIf="isVisible">
      <app-input-text-default *ngFor="let addressAttr of attribute.attributes"
          [attribute]="addressAttr"
          [process]="process"
          [envOptions]="envOptions"
          (input)="onValueChange(addressAttr, $event.target.value)"
          (onEmit)="emitEvents($event)">
      </app-input-text-default>
      <button type="button" class="btn btn-sm btn-secondary" *ngIf="enableEditButton" (click)="isVisible = false">
        <i class="fas fa-check"></i> Fechar campos de endereço</button>
  </div>
</div>

<div *ngIf="checkViewMode('view')">
  <p><span>Endereço:</span> {{ attribute.value }}</p>
</div>
